<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import { FormGroup, Input, InputGroup, InputGroupText } from "sveltestrap";
    import BookmarkDropmenu from "./BookmarkDropmenu.svelte";
</script>

<li class="onhover-dropdown">
    <div class="bookmark-box">
        <FeatherIcon icon="star" />
    </div>
    <div class="bookmark-dropdown onhover-show-div">
        <FormGroup class="mb-0">
            <InputGroup>
                <InputGroupText>
                    <i class="fa fa-search" />
                </InputGroupText>
                <Input
                    type="text"
                    placeholder="Search for bookmark..."
                />
            </InputGroup>
        </FormGroup>
        <BookmarkDropmenu />
    </div>
</li>
